<template>
  <div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
class Manage extends Vue {

}
export default Manage;
</script>

<style scoped>

</style>
